export function extrairListenersDosAttrs (attrs = {}, eventosIgnorados = []) {
  return Object.keys(attrs)
    .filter(chave => chave.startsWith('on'))
    .reduce((resultado, chave) => {
      const nomeDoEvento = chave
        .replace(/^on/, '')
        .replace(/^[A-Z]/, letra => letra.toLowerCase())

      if (!eventosIgnorados.includes(nomeDoEvento)) {
        resultado[nomeDoEvento] = attrs[chave]
      }

      return resultado
    }, {})
}

export function extrairAtributosDosAttrs (attrs = {}, atributosIgnorados = []) {
  return Object.keys(attrs)
    .filter(chave => !chave.startsWith('on'))
    .filter(chave => !atributosIgnorados.includes(chave))
    .reduce((resultado, chave) => {
      resultado[chave] = attrs[chave]
      return resultado
    }, {})
}

export function extrairAtributosDeControle (attrs = {}, atributosIgnorados = []) {
  return extrairAtributosDosAttrs(attrs, ['class', 'style', ...atributosIgnorados])
}

export function extrairClasseDoContainer (attrs = {}) {
  return attrs.class
}

export function extrairEstiloDoContainer (attrs = {}) {
  return attrs.style
}

export function localListenersAndAttributes ({
  ignoredEvents = ['input'],
  ignoredAttrs = ['disabled']
} = {}) {
  return {
    computed: {
      localListeners () {
        return extrairListenersDosAttrs(this.$attrs, ignoredEvents)
      },
      localAttributes () {
        return extrairAtributosDeControle(this.$attrs, ignoredAttrs)
      },
      rootClass () {
        return extrairClasseDoContainer(this.$attrs)
      },
      rootStyle () {
        return extrairEstiloDoContainer(this.$attrs)
      }
    }
  }
}
